<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

const defaultLayout = "default";

// Adding some comments before removing the project

export default {
  components: {},
  setup() {
    const route = useRoute();
    const layout = computed(
      () => `${route.meta.layout || defaultLayout}-layout`
    );

    return { layout };
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700&family=Rubik:wght@900&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

input,
textarea,
button,
select,
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>
